import { render } from "./Days.vue?vue&type=template&id=498a4a92&scoped=true"
import script from "./Days.vue?vue&type=script&lang=ts"
export * from "./Days.vue?vue&type=script&lang=ts"

import "./Days.vue?vue&type=style&index=0&id=498a4a92&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-498a4a92"

export default script